/**
 * Product master-data contract (RBAC area: `products`).
 *
 * `unitPrice` is a decimal serialized as a string end-to-end — never a JS float
 * (see docs/conventions.md money rules).
 */
/** When a recurring charge's period is shown relative to the billing run. */
export const BILLING_TIMINGS = ['arrears', 'advance'];
export const BILLING_TIMING_LABELS = {
    arrears: 'Arrears',
    advance: 'Advance',
};
/** How a product is classified within the PSA (drives agreement vs. service handling). */
export const PSA_CLASSES = ['agreement', 'service'];
export const PSA_CLASS_LABELS = {
    agreement: 'Agreement',
    service: 'Service',
};
//# sourceMappingURL=product.js.map